import React, { useContext } from "react";
import { Image } from "react-bootstrap";
import { langMap } from "./i18n";
import RestrictedViewImage from "../../assets/img/limited_devieces.png";
import LanguageContext from "../../utils/context/i18n/languageContext";

const RestrictedPage = () => {
    const lang = useContext(LanguageContext).lang
    return (
        <div className="restricted_page">
            <Image className="restricted_image" src={RestrictedViewImage} />
            <b className="restricted_title">{langMap.title[lang]}</b>
        </div>    
    )               
}

export default RestrictedPage;